import {
  Box,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useDisclosure
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { getFromUrl } from '../../api/Api';
import { colors } from '../../theme/colors';
import { capitalize, hexToRgbA } from '../../utils/helper';
import { Body, Caption } from '../Texts/Texts';

interface ChatBubbleProps {
  chat: any;
  previousDate: string;
  type?: string;
  counsellor?: any;
}

const ChatBubble = ({ chat, type, counsellor }: ChatBubbleProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = useState(false);
  const [media, setMedia] = useState<string | null>(null);

  useEffect(() => {
    if (chat) {
      console.log('chat:', chat);
    }
  }, [chat]);

  const handleMedia = (mediaId: string) => {
    if (mediaId) {
      getFromUrl(`webhook/media/${mediaId}`, 'file').then((res) => {
        const objectUrl = window.URL.createObjectURL(res);
        setIsLoading(false);
        setMedia(objectUrl);
      });
    }
  };

  const downloadDocument = () => {
    if (media) window.open(media);
  };

  // useEffect(() => {
  //   if (chat.type !== 'text' && chat.type !== 'interactive') {
  //     if (chat.status === 'pending') {
  //       const objectUrl = window.URL.createObjectURL(chat[chat.type].media);
  //       setMedia(objectUrl);
  //     } else handleMedia(chat[chat.type].id);
  //   }
  // }, []);

  const formatTimestamp = (timestamp: any) => {
    if (!timestamp) return '';
    
    let date;
    
    // Handle different timestamp formats
    if (typeof timestamp === 'string') {
      // If it's already a date string (like from createdAt)
      if (timestamp.includes('T') || timestamp.includes('-')) {
        date = new Date(timestamp);
      } else {
        // If it's a Unix timestamp (string)
        date = new Date(parseInt(timestamp) * 1000);
      }
    } else if (typeof timestamp === 'number') {
      // If it's a Unix timestamp (number)
      date = new Date(timestamp * 1000);
    } else {
      return '';
    }
    
    // Check if date is valid
    if (isNaN(date.getTime())) return '';
    
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();
    const isYesterday = date.toDateString() === new Date(now.getTime() - 24 * 60 * 60 * 1000).toDateString();
    
    if (isToday) {
      // Show only time for today's messages
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    } else if (isYesterday) {
      // Show "Yesterday" + time
      return `Yesterday ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
    } else {
      // Show date + time for older messages
      return date.toLocaleDateString([], { 
        month: 'short', 
        day: 'numeric',
        hour: '2-digit', 
        minute: '2-digit' 
      });
    }
  };

  const timeStamp = formatTimestamp(chat?.timestamp || chat?.createdAt);

  // Determine if message is from counsellor/admin (should be on RIGHT)
  const isCounsellorOrAdmin = chat?.user?.role === 'SUPER_ADMIN' || 
                              chat?.user?.role === 'COUNSELLOR' ||
                              chat?.user?.role === 'ADMIN' ||
                              chat?.user?.role === 'COUNSELOR';
  
  // Alternative: Check if message is from current user (counsellor)
  const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
  const isFromCurrentUser = chat?.user?._id === currentUser._id;
  
  // Alternative: Check if user name matches counsellor name patterns
  const isCounsellorByName = chat?.user?.name && 
    (chat.user.name.toLowerCase().includes('counsellor') || 
     chat.user.name.toLowerCase().includes('mister money') ||
     chat.user.name.toLowerCase().includes('admin'));
  
  // PATIENT messages should be on LEFT (inbound), COUNSELLOR/ADMIN on RIGHT (outbound)
  const outbound = isCounsellorOrAdmin || isFromCurrentUser || isCounsellorByName;

  return (
    <Flex justifyContent={outbound ? 'flex-end' : 'flex-start'} mb='8px'>
      {type === 'community' ? (
        <Box>
          <Box
            borderRadius='18px'
            borderBottomLeftRadius={outbound ? '18px' : '4px'}
            borderBottomRightRadius={outbound ? '4px' : '18px'}
            bg={outbound ? colors.deep_blue : 'white'}
            color={outbound ? 'white' : 'black'}
            p='16px'
            w='280px'
            mb='4px'
            boxShadow={outbound ? '0 2px 8px rgba(5, 57, 107, 0.15)' : '0 2px 8px rgba(0, 0, 0, 0.1)'}
            border={outbound ? 'none' : '1px solid #e2e8f0'}
          >
            <Flex mb='12px' justifyContent='space-between'>
              <Caption color={outbound ? 'white' : colors.deep_blue} fontWeight={600}>
                {outbound
                  ? capitalize(counsellor?.name)
                  : capitalize(chat?.user?.name)}
              </Caption>
            </Flex>

            {chat?.type === 'text' && <Body size='14px' color={outbound ? 'white' : 'black'}>
              {chat?.text || chat?.message}
            </Body>}
          </Box>
          <Caption
            color='gray.500'
            textAlign={outbound === 'outbound' ? 'right' : 'left'}
            fontSize='11px'
            mt='6px'
            fontWeight={400}
            opacity='0.8'
          >
            {timeStamp}
          </Caption>
        </Box>
      ) : (
        <Box>
          <Box
            borderRadius='18px'
            borderBottomLeftRadius={outbound ? '18px' : '4px'}
            borderBottomRightRadius={outbound ? '4px' : '18px'}
            bg={outbound ? colors.deep_blue : 'white'}
            color={outbound ? 'white' : 'black'}
            p='16px'
            w='280px'
            mb='4px'
            boxShadow={outbound ? '0 2px 8px rgba(5, 57, 107, 0.15)' : '0 2px 8px rgba(0, 0, 0, 0.1)'}
            border={outbound ? 'none' : '1px solid #e2e8f0'}
          >
            {/* <Flex mb='12px' justifyContent='space-between'>
              <Caption color={outbound ? 'deep_blue' : 'warning'}>
                {outbound === 'outbound'
                  ? capitalize(counsellor?.name)
                  : capitalize(chat?.user?.name)}
              </Caption>
              <Caption color='gray'>
                {outbound === 'outbound' ? 'Counsellor' : 'Client'}
              </Caption>
            </Flex> */}
            {/* {(chat?.sticker || chat?.image) && media && (
              <Image
                src={media}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  onOpen();
                }}
              />
            )} */}
            {/* {chat?.video && media && (
              <video
                controls={true}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  onOpen();
                }}
              >
                <source src={media} type='video/mp4' />
              </video>
            )} */}
            {<Body size='14px' color={outbound ? 'white' : 'black'}>
              {chat?.text || chat?.messages?.[0] || chat?.message}
            </Body>}
            {/* {chat?.interactive && (
              <Body size='14px'>
                {chat?.interactive?.list_reply?.title ??
                  chat?.interactive?.body?.text}
              </Body>
            )} */}
            {/* {chat?.document && (
              <Body
                size='14px'
                fontWeight={600}
                bg={hexToRgbA(colors.gray, '0.1')}
                cursor='pointer'
                borderRadius={5}
                padding={5}
              >
                <Flex justifyContent='space-between' onClick={downloadDocument}>
                  <Text color={colors.deep_blue}>
                    {chat?.document?.caption}
                  </Text>
                  {isLoading ? (
                    <Spinner size='sm' color={colors.deep_blue} />
                  ) : (
                    <DownloadIcon color={colors.deep_blue} />
                  )}
                </Flex>
              </Body>
            )} */}
          </Box>
          <Caption
            color='gray.500'
            textAlign={outbound === 'outbound' ? 'right' : 'left'}
            fontSize='11px'
            mt='6px'
            fontWeight={400}
            opacity='0.8'
          >
            {timeStamp}
          </Caption>
        </Box>
      )}{' '}
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size={'2xl'}
        motionPreset='scale'
        scrollBehavior='inside'
      >
        <ModalOverlay />
        <ModalContent padding={10} w='max-content'>
          <ModalCloseButton color={colors.gray} fontSize={12} />
          <ModalBody>
            {media ? (
              chat.type === 'image' || chat.type === 'sticker' ? (
                <Image src={media} />
              ) : chat.type === 'video' ? (
                <video
                  src={media}
                  controls={true}
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    onOpen();
                  }}
                />
              ) : null
            ) : null}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Flex>
  );
};
export default ChatBubble;
